import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHead = ({ label, title, dark = false, align = "left" }) => (
  <div className={align === "center" ? "text-center" : ""}>
    <Reveal>
      <p className={`mono-label ${dark ? "text-gold" : "text-gold-deep"}`}>{label}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mt-3 leading-[1.08] ${
          dark ? "text-alabaster" : "text-teal-brand"
        }`}
      >
        {title}
      </h2>
    </Reveal>
  </div>
);
